// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @14.07.2017 13:53:29
import { CLocationHistory_abstract } from './../../abstract/SagaSchema/History/CLocationHistory_abstract';

export class CLocationHistory extends CLocationHistory_abstract {
  getOLCoordinate(): ol.Coordinate {
    return this.coordinate.x ? [this.coordinate.x, this.coordinate.y] : null;
  }
}
